export const SHOW = 'show';
export const CREATE = 'create';
export const UPDATE = 'update';
export const DESTROY = 'destroy';